import React from 'react';
import { InfoTooltip } from '@fourthwall/components';
import * as S from './Header.styled';
export const Header = ({ data }) => {
    const { content, info } = data;
    return (React.createElement(S.Container, null,
        React.createElement(S.InnerContainer, null,
            React.createElement(S.Header, null, content),
            React.createElement(S.Tooltip, null,
                React.createElement(InfoTooltip, { content: info })))));
};
